import React, { useEffect, useState } from "react";
import { getTrilhaCliente } from "~services/GlobalServices";
import { useTheRouteList } from "../hooks/useTheRouteData";
import { useParams } from "react-router-dom";
import useModalAction from "~components/Modal/hooks/useModalAction";
import { db } from "~/db/db";

import useHeader from "~components/Header/hooks/useHeader";
import RotaDoDiaListagemCliente from "../components/Listagem/RotaDoDiaListagemCliente";
import GraficoCliente from "../components/Graficos/GraficoCliente";
import RotaDoDiaGraficoClientePesquisar from "../components/Graficos/RotaDoDiaGraficoClientePesquisar";
import { getSuccessFlag } from "~services/utils/NavigationUtils";
import RotaDoDiaDisclaimer from "../components/Layout/RotaDoDiaDisclaimer";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useFaturamento from "~fetchs/Roterizacao/useFaturamento";
import useMissao from "~fetchs/Roterizacao/useMissao";
import useInfoTatica from "~fetchs/Roterizacao/useInfoTatica";
import useGov from "~fetchs/Roterizacao/useGov";
import useLocalStorage from "~hooks/useLocalStorage";
import ModalResponse from "~components/Modal/ModalResponse";
import { isDesktop, isMobile } from "react-device-detect";
import { initialPath } from "~misc/paths";
import useVisitas from "~fetchs/Roterizacao/useVisitas";
import useCliente from "~fetchs/useCliente";

const RotaDoDiaGraficos = () => {
  const { path } = useHeader();
  const regexConsulta = /^\/roteirizacao\/consulta\/\d+$/;
  const isValidRouteConsulta = regexConsulta.test(path);

  const { parameter: clienteId } = useParams();
  const [validation, setLocalStorage] = useLocalStorage("loc", null);
  const [filters, setFilters] = useState({
    ordem: "",
    periodo: "",
    grupoMaterialId: 0,
    produtoId: 0,
  });

  const { visitaMaisRecenteCliente } = useVisitas({ filters });

  const { faturamentos, gruposMateriais, produtos, faturamentoLastCreatedAtDate } = useFaturamento({
    clienteId,
    filters,
  });
  const { govs } = useGov({ clienteId, filters });
  const { missoes, loading: loadingMissoes } = useMissao({ clienteId });
  const {
    infosTatica,
    blocosInfoTatica,
    loading: loadingInfosTatica,
    taticaLastCreatedAtDate,
  } = useInfoTatica({ clienteId });

  const [selects, setSelects] = useState({});

  const missoesSplit = visitaMaisRecenteCliente?.missoes.split(/\r?\n/).map((linha) => {
    const partes = linha.split(";");
    return {
      tipo: partes[0]?.trim(),
      direcionamento: partes.slice(1, -1).join(";").trim(),
      prioridade: partes.at(-1)?.trim(),
    };
  });

  const cleanFilters = () => {
    setFilters({
      ordem: "",
      periodo: "",
      grupoMaterialId: 0,
      produtoId: 0,
    });
    selects.grupoProdutoSelect.upDateValue(0);
    selects.produtoSelect.upDateValue(0);
    selects.grupoProdutoSelect.upDateDefaultValue({ label: "Todos", value: 0 });
    selects.produtoSelect.upDateDefaultValue({ label: "Todos", value: 0 });
  };

  const { cliente } = useCliente(+clienteId);

  const [startDate, setStartDate] = useState();

  const [trilhaCliente, setTrilhaCliente] = useState("");

  useEffect(() => {
    if (cliente?.trilha) setTrilhaCliente(getTrilhaCliente(cliente.trilha?.codigo));
  }, [cliente]);

  const { data, isLoading, error } = useTheRouteList();

  useEffect(() => {
    if (getSuccessFlag()) {
      openModalClearResponse();
    }
  }, []);

  const { openModalAction: openModalClearResponse } = useModalAction();

  return (
    <>
      <ClientHeader dados={cliente} />
      {isValidRouteConsulta && <RotaDoDiaDisclaimer />}

      <RotaDoDiaGraficoClientePesquisar
        trilhaName={cliente?.trilha?.nome}
        cleanFilters={cleanFilters}
        setStartDate={setStartDate}
        startDate={startDate}
      />

      <GraficoCliente
        faturamentos={faturamentos}
        faturamentoLastCreatedAtDate={faturamentoLastCreatedAtDate}
        filtros={{ gruposMateriais, produtos }}
        govs={govs}
        filters={filters}
        trilha={trilhaCliente}
        setFilters={setFilters}
        cleanFilters={cleanFilters}
        setStartDate={setStartDate}
        startDate={startDate}
        setSelects={setSelects}
        selects={selects}
      />
      <RotaDoDiaListagemCliente
        list={data}
        missoesSplit={missoesSplit}
        loading={isLoading}
        error={error}
        cliente={cliente}
        infosTatica={infosTatica}
        taticaLastCreatedAtDate={taticaLastCreatedAtDate}
        blocosInfoTatica={blocosInfoTatica}
        dadosMissoes={missoes}
        loadingMissoes={loadingMissoes}
        loadingInfosTatica={loadingInfosTatica}
      />
      <ModalResponse
        isOpen={validation?.status && isMobile}
        closeModal={() => {
          setLocalStorage(null);
          db.visitaAtiva.clear();
        }}
        status="alert"
        link={`${initialPath}/roteirizacao/mapa`}
        message="Atenção!"
        submessage="Houve um problema ao pegar sua localização, tente novamente em alguns instantes"
        button="Ok"
      />
      <ModalResponse
        isOpen={validation?.status && isDesktop}
        closeModal={() => {
          setLocalStorage(null);
        }}
        status="warning"
        message="Atenção!"
        submessage="Houve um problema ao pegar sua localização, tente novamente em alguns instantes"
        button="Ok"
      />
    </>
  );
};

export default RotaDoDiaGraficos;
